var _path;

import * as React from "react";

function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 17.15l.365 6.223a.667.667 0 00.666.627h2.298a.667.667 0 00.666-.627l.366-6.223a.667.667 0 00-.666-.705h-3.03a.667.667 0 00-.666.705zm4.513 9.961a2.333 2.333 0 11-4.666 0 2.333 2.333 0 014.666 0zm-.023-20c-1.024-1.776-3.594-1.779-4.62 0L4.36 30.222c-1.024 1.774.258 4 2.31 4h26.66c2.048 0 3.335-2.223 2.31-4L22.31 7.11zM6.955 31.055l12.756-22.11a.333.333 0 01.578 0l12.756 22.11a.333.333 0 01-.289.5H7.244a.333.333 0 01-.289-.5z"
  })));
}

export default SvgExclamationTriangle;